import { render, staticRenderFns } from "./MyRecognitionsView.vue?vue&type=template&id=c461b20e&scoped=true"
import script from "./MyRecognitionsView.vue?vue&type=script&lang=js"
export * from "./MyRecognitionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c461b20e",
  null
  
)

export default component.exports